import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "subPermissions"]
  static values = {
    requires: Array,
    grants: Array,
    section: String
  }

  connect() {
    this.updateRelatedPermissions()
    
    // Initialize sub-permissions visibility if this is a section checkbox
    if (this.hasSectionValue) {
      this.toggleSubPermissions()
    }
  }

  toggle(event) {
    // Store the checked state from the event
    this._checked = event.target.checked
    
    this.updateRelatedPermissions()
    this.toggleSubPermissions()
  }

  toggleSubPermissions() {
    // Only handle section checkboxes (those with section value)
    if (!this.hasSectionValue) return
    
    // Find the sub-permissions container for this section
    const subPermissionsContainer = document.getElementById(`${this.sectionValue}_permissions`)
    if (!subPermissionsContainer) return
    
    // Get the checked state from the input target or from the stored value
    const checked = this.hasInputTarget ? this.inputTarget.checked : this._checked
    
    // Show/hide based on checkbox state
    if (checked) {
      subPermissionsContainer.style.display = 'block'
    } else {
      subPermissionsContainer.style.display = 'none'
    }
  }

  updateRelatedPermissions() {
    // Get the checked state from the input target or from the stored value
    const checked = this.hasInputTarget ? this.inputTarget.checked : this._checked
    
    if (checked === undefined) return
    
    // Handle required permissions
    if (checked && this.requiresValue.length > 0) {
      this.requiresValue.forEach(permission => {
        const requiredCheckbox = document.querySelector(
          `input[name="user[role_permissions][${this.sectionValue}][permissions][${permission}]"]`
        )
        if (requiredCheckbox && !requiredCheckbox.checked) {
          requiredCheckbox.checked = true
          // Trigger change event to update any dependencies
          requiredCheckbox.dispatchEvent(new Event('change'))
        }
      })
    }
    
    // Handle granted permissions
    if (this.grantsValue.length > 0) {
      this.grantsValue.forEach(permission => {
        const grantedCheckbox = document.querySelector(
          `input[name="user[role_permissions][${this.sectionValue}][permissions][${permission}]"]`
        )
        if (grantedCheckbox) {
          grantedCheckbox.checked = checked
          grantedCheckbox.disabled = checked
          // Trigger change event to update any dependencies
          grantedCheckbox.dispatchEvent(new Event('change'))
        }
      })
    }
    
    // If unchecked, also uncheck any permissions that require this one
    if (!checked) {
      document.querySelectorAll(`input[name^="user[role_permissions][${this.sectionValue}][permissions]"]`).forEach(checkbox => {
        const controller = this.application.getControllerForElementAndIdentifier(
          checkbox.closest('[data-controller="permission-checkbox"]'),
          'permission-checkbox'
        )
        if (controller && controller.requiresValue.includes(this.inputTarget.name.match(/\[(\w+)\]$/)[1])) {
          checkbox.checked = false
          // Trigger change event to update any dependencies
          checkbox.dispatchEvent(new Event('change'))
        }
      })
    }
  }
} 